import {
  TICKET_TYPE_BLOCK_BOOKING,
  TICKET_TYPE_PAY_AS_YOU_GO,
  TICKET_TYPE_SINGLE_EVENT,
} from '../../listing-page/config/listing';

export const PROMO_CODE_LISTING_TYPE = 'promoCode';

export const NO_RESTRICTIONS_ELIGIBILITY_TYPE = 'noRestrictions';
export const NEW_CUSTOMERS_ONLY_ELIGIBILITY_TYPE = 'newCustomersOnly';
export const RETURNING_CUSTOMERS_ONLY_ELIGIBILITY_TYPE = 'returningCustomersOnly';

export const ELIGIBILITY_TYPES = [
  NO_RESTRICTIONS_ELIGIBILITY_TYPE,
  NEW_CUSTOMERS_ONLY_ELIGIBILITY_TYPE,
  RETURNING_CUSTOMERS_ONLY_ELIGIBILITY_TYPE,
];

export const APPLY_TO_SPECIFIC_LISTINGS_YES = 'yes';
export const APPLY_TO_SPECIFIC_LISTINGS_NO = 'no';

export const APPLY_TO_SPECIFIC_LISTINGS_OPTIONS = [
  APPLY_TO_SPECIFIC_LISTINGS_YES,
  APPLY_TO_SPECIFIC_LISTINGS_NO,
];

export const PROMO_CODE_ALWAYS_ACTIVE = 'alwaysActive';
export const PROMO_CODE_HAS_FIXED_DURATION = 'fixedDuration';

export const DURATION_TYPES = [PROMO_CODE_ALWAYS_ACTIVE, PROMO_CODE_HAS_FIXED_DURATION];

export const DISCOUNT_LINE_ITEM_CODE = 'line-item/discount';
export const DISCOUNT_LINE_ITEM_CHARGE_CODE = 'line-item/discount-charge';

export const DEFAULT_TIME_ZONE = 'Europe/London';
export const DEFAULT_LOCALE = 'en-GB';

export const ELIGIBILITY_TICKET_TYPES = [
  {
    label: 'Single event',
    key: TICKET_TYPE_SINGLE_EVENT,
  },
  {
    label: 'Pay as you go',
    key: TICKET_TYPE_PAY_AS_YOU_GO,
  },
  {
    label: 'Terms',
    key: TICKET_TYPE_BLOCK_BOOKING,
  },
];

export const ALL_ELIGIBILITY_TICKET_TYPES_IS_SELECTED = 'all';

export const PERCENTAGE_DISCOUNT = 'percentageDiscount';
export const FIXED_AMOUNT_DISCOUNT = 'fixedAmountDiscount';
export const FREE_DISCOUNT = 'freeDiscount';

export const DISCOUNT_TYPES = [PERCENTAGE_DISCOUNT, FIXED_AMOUNT_DISCOUNT, FREE_DISCOUNT];

export const MAX_PERCENTAGE_DISCOUNT = 50;
